var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.data.type},[_c('shared-show',{attrs:{"type":_vm.data.type,"inputs":_vm.data.show.inputs,"lefts":_vm.data.show.leftCards,"rights":_vm.data.show.rightCards}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }